<div class="col-12 col-md-8 float-right p-0" *ngIf="isGraphicLoaded()">
  <p-panel styleClass="mb-3" [toggleable]="true" [collapsed]="totalProgress==='100%' || isFormalized()">
    <p-header>
      <i class="fa fas fa-lg fa-file-contract"></i>
      <span class="ml-2">{{ 'DossierBasicInfo.progress.procedureAdvance' | translate }}</span>
    </p-header>
    <div class="col-12 p-0">
      <!--canvas baseChart
        #chart
        class="chart" class="flot-overlay  m-t"
         [datasets]="chartTopData"
        [labels]="chartTopLabels"
        [chartType]="chartTopType"
        [colors]="chartColors"
        [options]="chartOptions"
        responsive="true"
        (onDataSelect)="onDataSelected($event)"></canvas-->
      <p-chart #chart (onDataSelect)="chartClicked($event)" responsive="true" type="{{this.chartTopType}}"
        [data]="this.chartTopData" height="40vh" style="left: 16%;" class="p-0 chart-center"></p-chart>
      <span style="position: absolute;top: 35%;left: 30%;font-size: 3em;width: 40%;text-align: center;">{{ totalProgress
        }}</span>
      <span *ngIf="isChartShowPhases()" style="position: absolute;top: 55%;left: 30%;width: 40%;text-align: center;">
        <small>{{ 'DossierBasicInfo.progress.dossier' | translate }}</small>
      </span>
      <span *ngIf="!isChartShowPhases()" style="position: absolute;top: 55%;left: 30%;width: 40%;text-align: center;">
        <small>{{ 'DossierBasicInfo.progress.phase' | translate }}</small>
      </span>
    </div>
    <div class="col-12 p-0">
      <ul class="category-list" style="padding-left: 0; ">
        <li *ngIf="!isChartShowPhases()" class="mt-2 m-b-2 pb-5">
          <button (click)="processChartData()" type="button" class="btn btn-primary btn-sm">
            <i class="fas fa-chevron-left" aria-hidden="true"></i> {{ 'DossierBasicInfo.back.phase' | translate }}
          </button>
          <button *ngIf="isProcedureMapAvailable ()" (click)="viewBlockDef(phaseId,filteredData[0].DIVISION.value,'')"
            type="button" class="btn btn-outline-secondary btn-sm ml-2 float-right">
            <i class="fas fa-sitemap" aria-hidden="true"></i> {{ 'Tasks.procedureMap.viewMap' | translate }} </button>
        </li>
        <li *ngIf="isChartShowPhases() && isProcedureMapAvailable ()" class="mt-2 m-b-2 pb-5" style="min-height: 25px;">
          <button (click)="viewBlockDef(null,filteredData[0].DIVISION.value,'')" type="button"
            class="btn btn-outline-secondary btn-sm ml-2 float-right">
            <i class="fas fa-sitemap" aria-hidden="true"></i> {{ 'Tasks.procedureMap.viewMap' | translate }} </button>
        </li>
        <li *ngIf="!isChartShowPhases()"> {{ 'DossierBasicInfo.phase.blocks' | translate }} [ <b>{{ phaseStr }}</b>]:
        </li>
        <li *ngIf="isChartShowPhases()"> {{ 'DossierBasicInfo.phases' | translate }} </li>
        <li *ngFor="let elemento of chartTopLabels; let num = index">
          <a *ngIf="isChartShowPhases()" style="padding: 0px;" (click)="processChartData(elemento)">
            <i class="fa fa-circle" [style.color]="this.uiService.backgroundColor[num]"> </i>
            <small>{{ elemento }}</small>
          </a>
          <a *ngIf="!isChartShowPhases()" style="padding: 0px;"
            (click)="viewBlockDef(filteredData[num].FASE_REGLA.value,filteredData[num].DIVISION.value,filteredData[num].ID_BLOQUE.value)">
            <i class="fa fa-circle" [style.color]="this.uiService.backgroundColor[num]">
            </i>
            <small>{{ elemento }}</small> </a>
        </li>
      </ul>
    </div>
  </p-panel>
</div>